export type ROUTE =
  | "INDEX"
  | "ACTION_CENTER"
  | "DASHBOARD"
  | "INSIGHTS"
  | "NEW_INSIGHTS"
  | "REPORTS"
  | "COMPANY"
  | "MEMBERS"
  | "MEMBERS_IMPORT"
  | "MEMBERS_SUBSCRIBERS"
  | "MEMBERS_GROUPS"
  | "MEMBERS_REMOVED"
  | "REASONS_OF_USE"
  | "SCHEDULINGS"
  | "CONTRACTS"
  | "CONTRACTS_PAYMENTS"
  | "PAYMENTS"
  | "WALLET"
  | "REVIEWS"
  | "BOOKINGS_REPORT"
  | "PACKAGES"
  | "PACKAGE"
  | "SETTINGS"
  | "HELP"
  | "PRIVATE_OFFICES"
  | "PRIVATE_OFFICES_SCHEDULINGS"
  | "MY_OFFICES"
  | "EXCLUSIVE_OFFICES"
  | "CUSTOM_OFFICES"
  | "CUSTOM_OFFICES_TICKETS"
  | "CUSTOM_OFFICES_SERVICE_ORDERS";

export const DEFAULT_ROUTES: { [key in ROUTE]: string } = {
  INDEX: "/",
  ACTION_CENTER: "/ia-actions-center",
  DASHBOARD: "/painel",
  INSIGHTS: "/insights",
  NEW_INSIGHTS: "/new-insights",
  REPORTS: "/reports",
  COMPANY: "/company/*",
  MEMBERS: "/members",
  MEMBERS_IMPORT: "/import",
  MEMBERS_SUBSCRIBERS: "/subscribers",
  MEMBERS_GROUPS: "/groups",
  MEMBERS_REMOVED: "/removed",
  REASONS_OF_USE: "/reasons-of-use",
  SCHEDULINGS: "/schedulings",
  CONTRACTS: "/contracts",
  CONTRACTS_PAYMENTS: "/contracts/payments/:id",
  PAYMENTS: "/payments",
  WALLET: "/carteira",
  REVIEWS: "/dashboard/reviews",
  BOOKINGS_REPORT: "/dashboard/bookings-report",
  PACKAGES: "/packages/*",
  PACKAGE: "/:id/details",
  PRIVATE_OFFICES: "/private-offices",
  PRIVATE_OFFICES_SCHEDULINGS: "/private-offices/schedulings",
  SETTINGS: "/settings",
  HELP: "/help",
  MY_OFFICES: "/my-offices/*",
  EXCLUSIVE_OFFICES: "/exclusive-offices",
  CUSTOM_OFFICES: "/custom-offices/*",
  CUSTOM_OFFICES_TICKETS: "/tickets",
  CUSTOM_OFFICES_SERVICE_ORDERS: "/service-orders",
};

export const DEMO_ROUTES: { [key in ROUTE]: string } = {
  INDEX: "/demo",
  ACTION_CENTER: "/demo/ia-actions-center",
  DASHBOARD: "/demo/dashboard",
  INSIGHTS: "/demo/insights",
  NEW_INSIGHTS: "/demo/new-insights",
  REPORTS: "/demo/reports",
  COMPANY: "/demo/company/*",
  MEMBERS: "/members",
  MEMBERS_SUBSCRIBERS: "/subscribers",
  MEMBERS_GROUPS: "/groups",
  MEMBERS_REMOVED: "/removed",
  REASONS_OF_USE: "/demo/reasons-of-use",
  MEMBERS_IMPORT: "/import",
  SCHEDULINGS: "/demo/schedulings",
  CONTRACTS: "/demo/contracts",
  CONTRACTS_PAYMENTS: "/demo/contracts/payments/:id",
  PAYMENTS: "/demo/payments",
  WALLET: "/demo/carteira",
  REVIEWS: "/demo/dashboard/reviews",
  BOOKINGS_REPORT: "/demo/dashboard/bookings-report",
  PACKAGES: "/demo/new-packages/*",
  PACKAGE: "/:id/details",
  PRIVATE_OFFICES: "/demo/private-offices",
  PRIVATE_OFFICES_SCHEDULINGS: "/demo/private-offices/schedulings",
  SETTINGS: "/demo/settings",
  HELP: "/demo/help",
  MY_OFFICES: "/demo/my-offices/*",
  EXCLUSIVE_OFFICES: "/exclusive-offices",
  CUSTOM_OFFICES: "/custom-offices/*",
  CUSTOM_OFFICES_TICKETS: "/tickets",
  CUSTOM_OFFICES_SERVICE_ORDERS: "/service-orders",
};

/**
 * ROUTES estático: avaliado uma vez na importação do módulo.
 * Seguro apenas onde o prefixo demo/padrão não muda em tempo de execução
 * (e.g. `<Route path={ROUTES.DASHBOARD} />`).
 *
 * ⚠️  Para guardiões reativos (esconder bolha de chat, detectar demo em testes)
 *     use `useActiveRoutes()` que relê o pathname via `useLocation`.
 */
export const ROUTES = window.location.pathname.startsWith(DEMO_ROUTES.INDEX)
  ? DEMO_ROUTES
  : DEFAULT_ROUTES;
